import { GET_ADDCHOOSEYOURSERVICE, GET_ADDCHOOSEYOURSERVICE_REQUESTED, GET_ADDCHOOSEYOURSERVICE_FAILED, GET_ADDCHOOSEYOURSERVICE_SUCCESS, GET_UPDATECHOOSEYOURSERVICE, GET_UPDATECHOOSEYOURSERVICE_FAILED, GET_UPDATECHOOSEYOURSERVICE_REQUESTED, GET_UPDATECHOOSEYOURSERVICE_SUCCESS, GET_CHOOSEYOURSERVICE, GET_CHOOSEYOURSERVICE_FAILED, GET_CHOOSEYOURSERVICE_REQUESTED, GET_CHOOSEYOURSERVICE_SUCCESS } from "resources/actionTypes";


const initialState = {
  userChooseYourService: [],
  loading: false,
  error: null,
};

const initialStateAdd = {
  userAddChooseYourService: [],
  loading: false,
  error: null,
}

const initialStateUpdate = {
  userUpdateChooseYourService: [],
  loading: false,
  error: null,
}

export function userChooseYourService(state =
  initialState, action) {
  switch (action.type) {
    case GET_CHOOSEYOURSERVICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CHOOSEYOURSERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        userChooseYourService: action.userChooseYourService
      };
    case GET_CHOOSEYOURSERVICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAddChooseYourService(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDCHOOSEYOURSERVICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDCHOOSEYOURSERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        userChooseYourService: action.userChooseYourService,
      };
    case GET_ADDCHOOSEYOURSERVICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateChooseYourService(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATECHOOSEYOURSERVICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATECHOOSEYOURSERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        userChooseYourService: action.userChooseYourService,
      };
    case GET_UPDATECHOOSEYOURSERVICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}